import { Grid, TextField } from "@mui/material";
import React from "react";
import GoogleAddressSelect from "../../carecoordinator/patient/GoogleAddressSelect";
import TeamMultiselect from "../../carecoordinator/patient/TeamMultiselect";

const AddEditOfficeForm = ({ officeDetails, setOfficeDetails, errors }) => {
  const handleChange = (e) => {
    const { name, value } = e.target;
    setOfficeDetails((prevUser) => ({
      ...prevUser,
      [name]: value,
    }));
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid xs={12} item>
          <TextField
            required
            fullWidth
            value={officeDetails?.name}
            name="name"
            label="Office Name"
            variant="outlined"
            error={errors?.name}
            helperText={errors?.name}
            onChange={handleChange}
          />
        </Grid>
        <Grid xs={12} item>
          <TeamMultiselect
            data={officeDetails}
            setData={setOfficeDetails}
            error={errors}
            label="Team"
            required={true}
          />
        </Grid>
        <Grid xs={12} item>
          <TextField
            fullWidth
            label="Medicare Provider Number"
            name="medicareProviderNumber"
            value={officeDetails?.medicareProviderNumber}
            variant="outlined"
            onChange={handleChange}
          />
        </Grid>
        <Grid xs={12} item>
          <TextField
            fullWidth
            label="National Provider Identifier"
            name="nationalProviderIdentifier"
            value={officeDetails?.nationalProviderIdentifier}
            variant="outlined"
            onChange={handleChange}
          />
        </Grid>
        <Grid xs={12} item>
          <GoogleAddressSelect
            address={officeDetails?.address}
            setData={setOfficeDetails}
          />
        </Grid>
        <Grid xs={12} item>
          <TextField
            fullWidth
            value={officeDetails?.notes}
            multiline
            rows={2}
            name="notes"
            label="Notes"
            variant="outlined"
            onChange={handleChange}
            sx={{ height: "auto", "& .MuiInputBase-root": { height: "auto" } }}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AddEditOfficeForm;
